import {
  Box,
  Button,
  CircularProgress,
  Container,
  TextField,
  Typography,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { useFeedbackSystem } from "../../hooks/useFeedbackSystem";

export default function Login() {
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");

  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isLogged) {
      const fromPath = location.state?.from?.pathname || "/";
      navigate(fromPath, { replace: true });
    }
  }, [auth.isLogged, location.state?.from?.pathname, navigate]);
  const feedback = useFeedbackSystem();

  const loginHandler = useCallback(() => {
    if (
      password != null &&
      password.length !== 0 &&
      username != null &&
      username.length !== 0
    ) {
      auth.signIn!(username, password).then(
        (response) => {
          if (response.status === "KO") {
            feedback.show({
              type: "warning",
              message: response.message,
            });
          }
        },
        (error) => {
          feedback.show({
            type: "warning",
            message: error.response.statusText,
          });
        },
      );
    }
  }, [feedback, password, auth.signIn, username]);

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
      }}
    >
      <Container
        maxWidth="sm"
        sx={{ height: "100%", alignItems: "center", display: "flex" }}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          width={"100%"}
          gap={2}
          alignItems={"center"}
        >
          <img
            height={70}
            width={70}
            src="./img/trendrating_icon_transparent_128x128_black.png"
            alt="trendrating logo"
          />
          <Typography variant="h2">Support</Typography>
          <TextField
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                loginHandler();
              }
            }}
            label="Email"
            color="secondary"
            type="email"
            onChange={(val) => {
              setUsername(val.target.value);
            }}
          />
          <TextField
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                loginHandler();
              }
            }}
            label="Password"
            type="password"
            color="secondary"
            onChange={(val) => {
              setPassword(val.target.value);
            }}
          />
          <Button
            onClick={() => loginHandler()}
            color="secondary"
            disabled={auth.isLoading}
            endIcon={
              auth.isLoading && (
                <CircularProgress color="secondary" size={"1em"} />
              )
            }
          >
            Sign in
          </Button>

          <Box pt={10}>
            <Footer />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const startYear = 2013;

  return (
    <Typography>
      &copy; {startYear} - {currentYear} Trendrating SA. All rights are
      reserved.
    </Typography>
  );
};
